import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/events", label: "事件追踪" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || open;
  const textBase = solid ? "text-foreground-800" : "text-background-50";
  const activeBase = solid ? "text-primary-600" : "text-background-50";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
            <i className="ri-radar-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {siteInfo.name}
            </span>
            <span
              className={`text-[10px] tracking-[0.28em] mt-1 ${
                solid ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              {siteInfo.tagline}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? `${activeBase} font-medium bg-background-100/60`
                    : `${textBase} hover:text-primary-600`
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/events"
            className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              solid
                ? "text-foreground-600 hover:text-primary-600 hover:bg-background-100"
                : "text-background-100 hover:text-background-50"
            }`}
            aria-label="搜索事件"
          >
            <i className="ri-search-line text-lg" />
          </Link>
          <Link
            to="/#tips"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-upload-2-line" />
            提供线索
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            solid ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-5 pb-6 pt-3">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm border-b border-background-100 last:border-0 cursor-pointer ${
                    isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/#tips"
            className="mt-4 inline-flex w-full items-center justify-center gap-1.5 px-4 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 cursor-pointer"
          >
            <i className="ri-upload-2-line" />
            提供线索
          </Link>
        </div>
      )}
    </header>
  );
}